// extracted by mini-css-extract-plugin
module.exports = {"container":"AdminAdd_container__3w2w3","some-fields":"AdminAdd_some-fields__2743X"};